module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASklEQVQ4y2P4jwQ+MAww7wADDNgPDh6QMSh4/P//M9j//zMoeAzM/xkYwEIDz+P/A0xCH5gHEQ8eYwPKg6QemMsGnjdI8vTgKesARNaw85v/mbUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDIrMDk6MDDfetBBAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00570_100x100.png
// module id = uLkF
// module chunks = 0